export default __webpack_public_path__ + "static/media/prayer-to-our-lady-of-the-miraculous-medal.3f4f4456.jpg";